import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon } from './icons';
export function EmotionalAmplification() {
  return <section className="py-24 bg-brand-bg-dark" data-id="element-57">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-58">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-59">
          <div className="flex items-center justify-center gap-4 mb-12" data-id="element-60">
            <HeartIcon className="w-10 h-10 text-brand-gold" data-id="element-61" />
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-white text-center" data-id="element-62">
              Tu Casa Merece Respeto
            </h2>
          </div>

          <div className="space-y-8 text-lg sm:text-xl text-gray-300" data-id="element-63">
            <p className="leading-relaxed" data-id="element-64">
              Tu casa no es solo una estructura. Es el resultado de años de
              trabajo. De sacrificio. De madrugar, trasnochar, y hacer lo que
              sea necesario para tener algo propio en este país.
            </p>

            <p className="text-2xl font-heading font-medium text-brand-gold" data-id="element-65">
              Merece ser tratada con respeto.
            </p>

            <p className="leading-relaxed" data-id="element-66">
              Merece un contratista que llegue cuando dice que llega. Que use
              materiales de calidad. Que te explique exactamente qué va a hacer
              y cuánto va a costar —{' '}
              <strong className="text-white" data-id="element-67">sin sorpresas al final.</strong>
            </p>

            <p className="leading-relaxed bg-brand-bg-light p-6 rounded border border-brand-gold/20" data-id="element-68">
              Y merece a alguien que entienda tu comunidad, porque vive y
              trabaja en ella.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}